import { EventEmitter, Injectable } from '@angular/core';
import { Gallery, ImageItem, ImageSize } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { COUNTRY_LIST, CONTINENT_LIST } from '@constants';
import { Country } from '@models';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    profileUpdateEvent: EventEmitter<any>;

    constructor(public gallery: Gallery, public lightbox: Lightbox) {
        this.profileUpdateEvent = new EventEmitter<any>();
    }

    getCountry(isoCode: string): Country {
        if (isoCode) {
            return COUNTRY_LIST.find((c: any) => c.isoCode === isoCode.toUpperCase());
        }
        return null;
    }

    getCountryName(isoCode: string): string {
        if (isoCode) {
            const country = COUNTRY_LIST.find((c) => c.isoCode === isoCode.toUpperCase());
            if (country) {
                return country.name;
            }
        }

        return '';
    }

    getContinentName(code: string): string {
        if (code) {
            if (CONTINENT_LIST[code]) {
                return CONTINENT_LIST[code];
            }
        }

        return '';
    }

    openPicture(src) {
        const items = [new ImageItem({ src, thumb: src })];
        const lightboxRef = this.gallery.ref('lightbox');
        lightboxRef.setConfig({
            imageSize: ImageSize.Cover,
            thumb: false,
        });
        lightboxRef.load(items);
        this.lightbox.open(0);
    }
}
